import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap5';

export default function ModalWithText({ show, text }) {
  return (

    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body>
        {text}
      </Modal.Body>
    </Modal>
  );
}

ModalWithText.propTypes = {
  show: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
};
